import * as React from "react";
import Svg, { Path, G, Mask, Circle, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SvgComponent(props) {
  return (
    <Svg width={120} height={120} viewBox="0 0 120 120" fill="none" {...props}>
      <Path
        d="M95.298 109.216L95 109.21a69.09 69.09 0 011.057-9.873c1.288-6.982 3.43-11.568 6.366-13.63l.171.245c-6.858 4.815-7.293 23.08-7.296 23.264z"
        fill="#2F2E41"
      />
      <Path
        d="M104.289 85.979a1.49 1.49 0 100-2.98 1.49 1.49 0 000 2.98z"
        fill="#FFCD9F"
      />
      <Path
        d="M98.327 86.871c.28 1.788-.45 3.387-.45 3.387s-1.183-1.3-1.463-3.087c-.28-1.788.45-3.387.45-3.387s1.183 1.3 1.463 3.087zM103.195 91.214c-1.712.587-3.413.147-3.413.147s1.073-1.392 2.785-1.979c1.712-.587 3.413-.147 3.413-.147s-1.073 1.391-2.785 1.979z"
        fill="#B9DD6E"
      />
      <Path
        d="M99.022 109.144l-.298-.005c.006-.33.192-8.105 3.253-10.253l.171.243c-2.937 2.062-3.125 9.936-3.126 10.015z"
        fill="#2F2E41"
      />
      <Path
        d="M103.552 98.787a1.49 1.49 0 100-2.979 1.49 1.49 0 000 2.98z"
        fill="#FF8D86"
      />
      <Path
        d="M103.25 102.557a4.634 4.634 0 01-2.392.103 4.219 4.219 0 014.345-1.49 4.646 4.646 0 01-1.953 1.387z"
        fill="#6EDD80"
      />
      <Path
        d="M14.168 109.348l-.007.044a7.448 7.448 0 01-.023-.129 16.616 16.616 0 01.674-8.342c.175-.511.374-1.012.597-1.503a16.652 16.652 0 013.574-5.103 7.337 7.337 0 011.657-1.243c.09-.046.18-.09.272-.13a3.095 3.095 0 011.819-.258 2.522 2.522 0 01.856.324c.413.265.767.61 1.037 1.015.27.405.453.86.535 1.336.118.711.091 1.438-.079 2.139a10.977 10.977 0 01-.5 1.574c-1.813 4.559-5.709 8.603-10.412 10.276z"
        fill="#A1BF62"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6 96.121a5.776 5.776 0 01-.255-3.588.125.125 0 01.152-.083.124.124 0 01.088.149 5.497 5.497 0 00.223 3.381 100.893 100.893 0 012.303-3.46c.091-.13.307-.006.215.125a100.503 100.503 0 00-4.652 7.34l.02.001c.497.048 1 .038 1.495-.03a6.814 6.814 0 004.48-2.596c.094-.126.31-.003.214.124a6.722 6.722 0 01-1.072 1.133 7.06 7.06 0 01-5.12 1.617.124.124 0 01-.11-.086 101.185 101.185 0 00-4.805 9.535c-.064.147-.278.021-.215-.123a100.746 100.746 0 017.12-13.38.125.125 0 01-.081-.06zm-5.27 8.948a5.705 5.705 0 01-.63-1.164 6.016 6.016 0 01-.386-2.954c.18-.538.384-1.065.614-1.582a.142.142 0 01.012.14 5.444 5.444 0 00-.347 1.209 5.752 5.752 0 00.952 4.228c.01.013.018.029.021.046a.101.101 0 01-.005.051.131.131 0 01-.043.054.128.128 0 01-.065.025.125.125 0 01-.069-.01.13.13 0 01-.054-.043z"
        fill="#88A941"
      />
      <Path
        d="M13.71 103.946l.017.044-.093-.108a7.492 7.492 0 01-.15-.173c-1.912-2.292-3.17-4.965-3.664-7.789-.1-.55-.17-1.103-.21-1.658a15.516 15.516 0 01.837-6.356 7.102 7.102 0 01.993-1.917c.065-.085.131-.168.202-.248a3.443 3.443 0 011.684-1.09 3.121 3.121 0 011.033-.105c.558.048 1.098.199 1.587.443.489.243.916.575 1.255.973.5.596.865 1.275 1.072 1.997a10.422 10.422 0 01.346 1.677c.636 5.03-1.094 10.568-4.909 14.31z"
        fill="#A1BF62"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.53 88.247c.115-1.38.26-2.758.432-4.133.02-.158.268-.149.248.01a100.592 100.592 0 00-.71 8.662 6.477 6.477 0 001.328-.73 6.814 6.814 0 002.76-4.38c.026-.156.274-.147.249.01a6.72 6.72 0 01-.424 1.501 7.061 7.061 0 01-3.782 3.811.125.125 0 01-.138-.026 100.71 100.71 0 00.175 10.677c.01.159-.237.147-.248-.01a100.337 100.337 0 01.09-15.155.125.125 0 01-.1-.015 5.775 5.775 0 01-1.892-3.06.124.124 0 01.243-.053 5.496 5.496 0 001.768 2.891zm-.63 10.594a5.705 5.705 0 01-1.098-.738 6.018 6.018 0 01-1.715-2.437c-.09-.56-.154-1.122-.19-1.687a.142.142 0 01.075.12c.037.418.122.831.254 1.23a5.752 5.752 0 002.807 3.303.102.102 0 01.06.078.135.135 0 01-.193.13z"
        fill="#88A941"
      />
      <Path
        d="M13.669 109.364l.035.028a3.119 3.119 0 01-.125-.045 17.191 17.191 0 01-7-4.778 17.103 17.103 0 01-1.028-1.271 16.921 16.921 0 01-2.732-5.644 7.31 7.31 0 01-.279-2.052c.003-.1.009-.2.019-.3a3.01 3.01 0 01.665-1.695 2.453 2.453 0 01.705-.574 3.548 3.548 0 012.838-.17 5.548 5.548 0 011.84 1.143c.052.046.103.094.153.141.351.339.68.7.985 1.081 3.117 3.856 4.76 9.245 3.924 14.136z"
        fill="#A1BF62"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.26 96.772A100.823 100.823 0 013.4 93.056c-.069-.144.145-.27.214-.125a100.38 100.38 0 004.067 7.681l.01-.017c.289-.409.529-.85.716-1.313a6.814 6.814 0 00-.032-5.177c-.063-.145.15-.272.214-.126.208.479.359.98.45 1.493a7.06 7.06 0 01-1.134 5.248.127.127 0 01-.13.053 100.884 100.884 0 005.897 8.901c.096.129-.12.253-.213.126a100.39 100.39 0 01-8.086-12.819c-.024.028-.057.047-.093.042a5.774 5.774 0 01-3.241-1.559c-.116-.11.06-.286.175-.175a5.496 5.496 0 003.047 1.483zm5.175 9.265c-.44.041-.885.031-1.323-.031a6.02 6.02 0 01-2.757-1.129 17.806 17.806 0 01-1.069-1.319.147.147 0 01.072.013.149.149 0 01.056.047c.256.333.55.635.877.901a5.754 5.754 0 004.144 1.27.102.102 0 01.093.034.136.136 0 01.015.134.137.137 0 01-.108.08z"
        fill="#88A941"
      />
      <Path d="M109.5 109H7.5a.5.5 0 000 1h102a.5.5 0 000-1z" fill="#383838" />
      <Path
        d="M76.276 30.9h-.575V15.127A9.129 9.129 0 0066.573 6H33.159a9.128 9.128 0 00-9.128 9.128v86.522a9.121 9.121 0 002.674 6.454 9.126 9.126 0 006.454 2.674h33.414a9.123 9.123 0 006.454-2.674 9.114 9.114 0 002.674-6.454V42.125h.575V30.9z"
        fill="#3F3D56"
      />
      <Path
        d="M66.87 8.375h-4.362a3.24 3.24 0 01-2.998 4.461H40.367a3.238 3.238 0 01-2.998-4.461h-4.074a6.816 6.816 0 00-6.817 6.816v86.396a6.814 6.814 0 004.209 6.297 6.808 6.808 0 002.608.519H66.87a6.808 6.808 0 004.82-1.996 6.82 6.82 0 001.996-4.82V15.191a6.817 6.817 0 00-6.817-6.816z"
        fill="#F2F2F2"
      />
      <G filter="url(#prefix__filter0_d)">
        <Path
          d="M70.245 30.907H29.934a1.44 1.44 0 00-1.44 1.44v7.918c0 .795.645 1.44 1.44 1.44h40.311a1.44 1.44 0 001.44-1.44v-7.919a1.44 1.44 0 00-1.44-1.44z"
          fill="#fff"
        />
      </G>
      <Path
        d="M63.983 33.21H41.956a.504.504 0 100 1.008h22.027a.504.504 0 100-1.008zM49.586 35.802h-7.63a.504.504 0 100 1.008h7.63a.504.504 0 100-1.008zM57.504 38.393H41.955a.504.504 0 100 1.008h15.549a.504.504 0 100-1.008zM39 36a3.978 3.978 0 01-.943 2.58 4.018 4.018 0 01-1.126.924A3.965 3.965 0 0135 40a3.984 3.984 0 01-2.718-1.065A4 4 0 1139 36z"
        fill="#E6E6E6"
      />
      <Path
        d="M37 39.313a3.471 3.471 0 01-1.991.686A3.446 3.446 0 0133 39.386a2.65 2.65 0 01.401-.617c.247-.283.546-.497.876-.627.33-.13.681-.171 1.027-.122.346.05.678.19.97.41.29.218.534.511.712.855l.014.029z"
        fill="#FF8D86"
      />
      <Path
        d="M34.899 37.341a1.67 1.67 0 100-3.341 1.67 1.67 0 000 3.341z"
        fill="#2F2E41"
      />
      <Path
        d="M35.978 36.849a1.243 1.243 0 10-2.181-1.193 1.243 1.243 0 002.181 1.193z"
        fill="#FFB8B8"
      />
      <Path
        d="M33.745 35.47c.284.196.621.3.966.299a1.037 1.037 0 01-.41.169 3.41 3.41 0 001.392.008c.102-.017.2-.05.292-.1a.37.37 0 00.18-.241c.03-.175-.106-.333-.247-.44a1.82 1.82 0 00-1.53-.306c-.171.044-.342.119-.453.256-.111.137-.144.35-.038.49l-.152-.135z"
        fill="#2F2E41"
      />
      <G filter="url(#prefix__filter1_d)">
        <Path
          d="M70.245 67.763H29.934a1.44 1.44 0 00-1.44 1.44v7.918c0 .795.645 1.44 1.44 1.44h40.311a1.44 1.44 0 001.44-1.44v-7.918a1.44 1.44 0 00-1.44-1.44z"
          fill="#fff"
        />
      </G>
      <Path
        d="M63.983 70.067H41.956a.504.504 0 100 1.007h22.027a.504.504 0 100-1.007zM49.586 72.658h-7.63a.504.504 0 100 1.008h7.63a.504.504 0 100-1.008zM57.504 75.25H41.955a.504.504 0 100 1.007h15.549a.504.504 0 100-1.008zM39.199 72.6a3.58 3.58 0 01-.849 2.32 3.613 3.613 0 01-1.013.832 3.567 3.567 0 01-1.738.447 3.582 3.582 0 01-2.446-.96 3.6 3.6 0 116.045-2.64z"
        fill="#E6E6E6"
      />
      <Path
        d="M76.724 47.463H21.44a1.44 1.44 0 00-1.44 1.44v11.662c0 .795.645 1.44 1.44 1.44h55.284a1.44 1.44 0 001.44-1.44V48.903a1.44 1.44 0 00-1.44-1.44z"
        fill="#fff"
      />
      <Path
        d="M67.791 50.565H38.128a.679.679 0 100 1.358H67.79a.679.679 0 100-1.358zM48.403 54.055H38.128a.679.679 0 100 1.357h10.275a.679.679 0 100-1.357zM59.067 57.545h-20.94a.679.679 0 100 1.357h20.94a.679.679 0 100-1.357zM32 54a3.978 3.978 0 01-.943 2.58 4.018 4.018 0 01-1.126.924A3.965 3.965 0 0128 58a3.984 3.984 0 01-2.718-1.065A4 4 0 1132 54z"
        fill="#E6E6E6"
      />
      <Path
        d="M30 57.313a3.471 3.471 0 01-1.991.686A3.446 3.446 0 0126 57.386a2.65 2.65 0 01.401-.617c.247-.283.546-.497.876-.627.33-.13.681-.171 1.027-.122.346.05.678.19.97.41.29.218.534.511.711.855l.015.029z"
        fill="#E40046"
      />
      <Path
        d="M29.221 53.755a1.61 1.61 0 11-1.61-1.61 1.602 1.602 0 011.61 1.61z"
        fill="#2F2E41"
      />
      <Path
        d="M28.873 54.756a1.199 1.199 0 11-2.23-.879 1.199 1.199 0 012.23.879z"
        fill="#A0616A"
      />
      <Path
        d="M28.916 52.418a.847.847 0 00-.782-.416c-.164.012-.32.072-.473.132l-.777.303c-.202.079-.422.175-.51.373-.08.183-.02.395.041.586l.291.907c.04-.203.08-.41.165-.6a.929.929 0 01.403-.459c.202-.103.44-.101.667-.09.321.015.67.056.899.282.121.13.203.29.237.463.033.173.05.348.05.524.131-.227.242-.465.331-.711.073-.184.115-.378.123-.575a.809.809 0 00-.185-.547c-.132-.147-.346-.227-.534-.169"
        fill="#2F2E41"
      />
      <Mask
        id="prefix__a"
        maskUnits="userSpaceOnUse"
        x={31}
        y={69}
        width={8}
        height={8}
      >
        <Path
          d="M38.572 73.162a3.579 3.579 0 01-.848 2.32 3.616 3.616 0 01-1.014.832 3.567 3.567 0 01-1.737.447 3.587 3.587 0 01-2.446-.959 3.6 3.6 0 116.045-2.64z"
          fill="#E6E6E6"
        />
      </Mask>
      <G mask="url(#prefix__a)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35 74a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 3.5c1.38 0 2.5-.672 2.5-1.5s-1.12-1.5-2.5-1.5-2.5.672-2.5 1.5 1.12 1.5 2.5 1.5z"
          fill="#C4C4C4"
        />
      </G>
      <Path
        d="M95 90a24.862 24.862 0 01-4.065 13.665 25.093 25.093 0 01-8.867 8.233 24.792 24.792 0 01-9.712 2.99 24.913 24.913 0 01-8.809-.732 23.91 23.91 0 01-3.49-1.211 23.515 23.515 0 01-1.694-.814 24.646 24.646 0 01-3.766-2.44 25.005 25.005 0 01-9.247-23.862 25.002 25.002 0 0126.744-20.741A24.999 24.999 0 0195 90.002v-.001z"
        fill="#fff"
      />
      <Path
        d="M63.942 92.259s2.276 6.323.508 9.862c-1.769 3.539 2.781 7.586 2.781 7.586s11.886-6.069 10.368-9.104c-1.517-3.034-4.046-7.08-3.54-9.609L63.942 92.26z"
        fill="#FFB8B8"
      />
      <Path
        d="M68.367 94.661a8.092 8.092 0 100-16.184 8.092 8.092 0 000 16.184z"
        fill="#FFB8B8"
      />
      <Path
        d="M63.548 114.155a24.037 24.037 0 01-3.49-1.212l.217-6.143 2.275-5.059a10.53 10.53 0 001.636 1.053c.138.076.276.148.43.221 2.134 1.031 5.62 1.938 9-.591a12.872 12.872 0 003.109-3.5l6.31 3.576.331 3.874.384 4.508c-.545.361-1.105.699-1.68 1.015a24.792 24.792 0 01-9.712 2.991c-.775.075-1.563.111-2.358.111a24.92 24.92 0 01-6.452-.844z"
        fill="#575A89"
      />
      <Path
        d="M65.1 97.956v.01l-.318 3.302-.167 1.747-.246 2.597-.82 8.543a24.033 24.033 0 01-3.49-1.212 23.1 23.1 0 01-1.695-.814 24.64 24.64 0 01-3.766-2.439l-.9-4.154.07-.046L65.1 97.956zM82.067 111.896a24.793 24.793 0 01-9.711 2.991c.185-3.073.453-6.041.758-8.684.158-1.356.323-2.624.5-3.779.547-3.713 1.138-6.235 1.562-6.576l2.797 1.846 11.38 4.045-.247 4.38a25.117 25.117 0 01-7.038 5.777z"
        fill="#575A89"
      />
      <Path
        d="M54.597 109.69a23.91 23.91 0 01-1.586-1.35l.433-2.803.323-.047 1.448-.206 3.149 6.845a24.64 24.64 0 01-3.766-2.439h-.001zM90.936 103.665a25.117 25.117 0 01-8.867 8.232l-.3-1.303 1.596-4.219 1.944-5.139 4.044.508c.561.612 1.09 1.253 1.583 1.921z"
        fill="#575A89"
      />
      <Path
        d="M76.081 79.25a9.454 9.454 0 00-5.376-4.11l-1.644 1.315.639-1.534a8.698 8.698 0 00-1.625-.093l-1.48 1.902.613-1.837a9.364 9.364 0 00-6.46 3.843c-1.882 2.715-2.2 6.49-.347 9.226.507-1.562 1.125-3.028 1.633-4.59.4.054.805.056 1.205.005l.618-1.443.173 1.382c1.917-.167 4.76-.534 6.577-.87l-.177-1.061 1.058.881c.556-.128.887-.245.86-.333 1.351 2.179 2.69 3.57 4.042 5.75.512-3.073 1.417-5.629-.309-8.433z"
        fill="#2F2E41"
      />
      <Path
        d="M75.634 87.41c.302 0 .548-.49.548-1.095s-.246-1.096-.548-1.096c-.303 0-.548.491-.548 1.096 0 .605.245 1.096.548 1.096z"
        fill="#FFB8B8"
      />
      <G filter="url(#prefix__filter2_d)">
        <Circle cx={88} cy={76} r={12} fill="#fff" />
      </G>
      <Path
        d="M88.486 76.557h4.13a.485.485 0 100-.972h-4.13v-4.13a.485.485 0 10-.972 0v4.13h-4.13a.485.485 0 100 .972h4.13v4.13a.485.485 0 10.972 0v-4.13z"
        fill="#000"
        fillOpacity={0.3}
      />
      <Path
        d="M105.885 109.741L100 101s8.912 3.111 7.9 8.741h-2.015z"
        fill="#415F46"
      />
      <Path
        d="M106.115 109.741L112 101s-8.912 3.111-7.9 8.741h2.015z"
        fill="#63AC6F"
      />
      <Defs />
    </Svg>
  );
}

export default SvgComponent;
